import api from "../api";

export const addStatus = (payload) => api.post("/statuses/add", payload);

export const getStatuses = (params) =>
  api.get("/statuses", { params });

export const updateStatus = (id, payload) =>
  api.post(`/statuses/edit/${id}`, payload);

export const deleteStatus = (id) =>
  api.post(`/statuses/delete/${id}`);
